import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    width: 80px;
`;

export const ImageWrapper = styled.figure`
    display: block;
    margin: 0 auto;
    width: 80px;
    height: 80px;
    background: #f7f7f7;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    z-index: 9;
    pointer-events: none;
`;

export const Image = styled.img`
    width: 100%;
    min-height: 80px;
    min-width: 80px;
    object-fit: cover;
`;

export const ProfileDropdown = styled.div`
    position: absolute;
    bottom: -5px;
    right: 0;
    z-index: 10;
    width: 30px;
    height: 30px;
`;

export const Input = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const Wrapper = styled.section`
    display: flex;
    align-items: center;
    flex-direction: column;
`;
